import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './MuCentralOffice.module.scss';

const MuCentralOffice = () => {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.dashboardContent}>
        <div className={styles.header}>
          <div className={styles.logoSection}>
            <div className={styles.logo}>
              <span role="img" aria-label="university">🏛️</span>
            </div>
            <div className={styles.titleSection}>
              <h1>मध्यपश्चिम विश्वविद्यालय</h1>
              <h2>Mid-West University</h2>
              <h3>Central Office Dashboard</h3>
              <p>Bank Account Management System</p>
            </div>
          </div>
        </div>

        <div className={styles.cardsContainer}>
          <div className={`${styles.card} ${styles.adminCard}`} onClick={() => handleNavigation('/central-account-mu')}>
            <div className={styles.cardIcon}>
              <span role="img" aria-label="admin">👨‍💼</span>
            </div>
            <div className={styles.cardContent}>
              <h3>Admin Panel</h3>
              <p>Manage and view all bank account details</p>
              <div className={styles.authBadge}>
                <span className={styles.authIcon}>🔒</span>
                <span>Login Required</span>
              </div>
            </div>
            <div className={styles.cardArrow}>
              <span>→</span>
            </div>
          </div>

          <div className={`${styles.card} ${styles.publicCard}`} onClick={() => handleNavigation('/bank-survey')}>
            <div className={styles.cardIcon}>
              <span role="img" aria-label="add">➕</span>
            </div>
            <div className={styles.cardContent}>
              <h3>Add Bank Details</h3>
              <p>Submit new bank account information</p>
              <div className={styles.publicBadge}>
                <span className={styles.publicIcon}>🌐</span>
                <span>Public Access</span>
              </div>
            </div>
            <div className={styles.cardArrow}>
              <span>→</span>
            </div>
          </div>

          <div className={`${styles.card} ${styles.publicCard}`} onClick={() => handleNavigation('/tokenedit')}>
            <div className={styles.cardIcon}>
              <span role="img" aria-label="edit">✏️</span>
            </div>
            <div className={styles.cardContent}>
              <h3>Edit Bank Details</h3>
              <p>Update existing bank account information</p>
              <div className={styles.publicBadge}>
                <span className={styles.publicIcon}>🌐</span>
                <span>Token Based</span>
              </div>
            </div>
            <div className={styles.cardArrow}>
              <span>→</span>
            </div>
          </div>
        </div>

        <div className={styles.infoSection}>
          <div className={styles.infoCard}>
            <h4>📋 How to Use</h4>
            <ul>
              <li><strong>Add Bank Details:</strong> Submit new bank account information (no login required)</li>
              <li><strong>Edit Bank Details:</strong> Update existing information using your reference token</li>
              <li><strong>Admin Panel:</strong> Full management access (requires login)</li>
            </ul>
          </div>
        </div>

        <div className={styles.footer}>
          <p>Select an option to proceed with bank account management</p>
          <div className={styles.footerLinks}>
            <span>Need help? Contact support</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MuCentralOffice;
